import Oidc from 'oidc-client'
import oidcSettings from './config'

Oidc.Log.logger = console
Oidc.Log.level = Oidc.Log.INFO

const auth = new Oidc.UserManager(oidcSettings)

auth.events.addUserLoaded(user => {
  if (process.env.NODE_ENV === 'development') {
    console.log('New User Loaded：', user)
  }
})

auth.events.addAccessTokenExpiring(args => {
  if (process.env.NODE_ENV === 'development') {
    console.log('AccessToken Expiring：', args)
  }
})

auth.events.addAccessTokenExpired(args => {
  if (process.env.NODE_ENV === 'development') {
    console.log('AccessToken Expired：', args)
  }
  auth
    .signoutRedirect()
    .then(resp => {
      if (process.env.NODE_ENV === 'development') {
        console.log('signed out', resp)
      }
    })
    .catch(err => {
      console.log(err)
    })
})

auth.events.addSilentRenewError(args => {
  if (process.env.NODE_ENV === 'development') {
    console.error('Silent Renew Error：', args)
  }
})

auth.events.addUserSignedOut(args => {
  if (process.env.NODE_ENV === 'development') {
    console.log('UserSignedOut：', args)
  }
  auth
    .signoutRedirect()
    .then(resp => {
      if (process.env.NODE_ENV === 'development') {
        console.log('signed out', resp)
      }
    })
    .catch(err => {
      console.log(err)
    })
})

function getUserSilent() {
  return new Promise((resolve, reject) => {
    if (process.env.NODE_ENV === 'development') {
      console.log('getUserSilent')
    }
    auth
      .getUser()
      .then(user => {
        if (!!user && !user.expired) {
          if (process.env.NODE_ENV === 'development') {
            console.log(
              'getUserSilent: user loaded from store. user: ' +
                user.profile.sub,
            )
          }
          resolve(user)
        } else {
          if (process.env.NODE_ENV === 'development') {
            console.log(
              'getUserSilent: user not found in store or expired. Trying signinSilent.',
            )
          }
          auth
            .signinSilent()
            .then(user => {
              if (!!user && !user.expired) {
                if (process.env.NODE_ENV === 'development') {
                  console.log(
                    'getUserSilent: signinSilent user loaded. user: ' +
                      user.profile.sub,
                  )
                }
                resolve(user)
              } else {
                if (process.env.NODE_ENV === 'development') {
                  console.log(
                    'getUserSilent: signinSilent user not found or expired.',
                  )
                }
              }
            })
            .catch(error => {
              console.log('getUserSilent: Error in signinSilent: ', error)
              reject(error)
            })
        }
      })
      .catch(error => {
        console.log('getUserSilent: Error in getUser: ', error)
        reject(error)
      })
  })
}
auth.getUserSilent = getUserSilent

function getUserRedirect() {
  return new Promise(resolve => {
    if (process.env.NODE_ENV === 'development') {
      console.log('getUserRedirect')
    }
    auth
      .getUserSilent()
      .then(user => {
        if (!!user && !user.expired) {
          if (process.env.NODE_ENV === 'development') {
            console.log(
              'getUserRedirect: getUserSilent: user loaded. user: ' +
                user.profile.sub,
            )
          }
          resolve(user)
        } else {
          if (process.env.NODE_ENV === 'development') {
            console.log(
              'getUserRedirect: getUserSilent: user not found. Calling signinRedirect { state: ' +
                window.location.href +
                ' }',
            )
          }
          auth.signinRedirect({ state: window.location.href })
        }
      })
      .catch(error => {
        console.log('getUserRedirect: Error in getUserSilent: ', error)
        if (process.env.NODE_ENV === 'development') {
          console.log(
            'getUserRedirect: Calling signinRedirect { state: ' +
              window.location.href +
              ' }',
          )
        }
        auth.signinRedirect({ state: window.location.href })
      })
  })
}
auth.getUserRedirect = getUserRedirect

// Renew the token manually
function renewToken() {
  let self = this
  return new Promise((resolve, reject) => {
    auth
      .signinSilent()
      .then(user => {
        if (user === null) {
          self.signIn(null)
        } else {
          return resolve(user)
        }
      })
      .catch(err => {
        console.log(err)
        return reject(err)
      })
  })
}
auth.renewToken = renewToken

// Get the user who is logged in
function getLoggedInUser() {
  let self = this
  return new Promise((resolve, reject) => {
    auth
      .getUser()
      .then(user => {
        if (user === null) {
          self.signIn()
          return resolve(null)
        } else {
          return resolve(user)
        }
      })
      .catch(err => {
        console.log(err)
        return reject(err)
      })
  })
}
auth.getLoggedInUser = getLoggedInUser

// Check if there is any user logged in
function getSignedIn() {
  let self = this
  return new Promise((resolve, reject) => {
    auth
      .getUser()
      .then(user => {
        if (user === null) {
          self.signIn()
          return resolve(false)
        } else {
          return resolve(true)
        }
      })
      .catch(err => {
        console.log(err)
        return reject(err)
      })
  })
}
auth.getSignedIn = getSignedIn

// Redirect of the current window to the authorization endpoint.
function signIn() {
  auth.signinRedirect().catch(err => {
    console.log(err)
  })
}
auth.signIn = signIn

// Redirect of the current window to the end session endpoint
function signOut() {
  auth
    .signoutRedirect()
    .then(resp => {
      if (process.env.NODE_ENV === 'development') {
        console.log('signed out', resp)
      }
    })
    .catch(err => {
      console.log(err)
    })
}
auth.signOut = signOut

// Get the profile of the user logged in
function getProfile() {
  let self = this
  return new Promise((resolve, reject) => {
    auth
      .getUser()
      .then(user => {
        if (user === null) {
          self.signIn()
          return resolve(null)
        } else {
          return resolve(user.profile)
        }
      })
      .catch(err => {
        console.log(err)
        return reject(err)
      })
  })
}
auth.getProfile = getProfile

// Get the token id
function getIdToken() {
  let self = this
  return new Promise((resolve, reject) => {
    auth
      .getUser()
      .then(user => {
        if (user === null) {
          self.signIn()
          return resolve(null)
        } else {
          return resolve(user.id_token)
        }
      })
      .catch(err => {
        console.log(err)
        return reject(err)
      })
  })
}
auth.getIdToken = getIdToken

// Get the session state
function getSessionState() {
  let self = this
  return new Promise((resolve, reject) => {
    auth
      .getUser()
      .then(user => {
        if (user === null) {
          self.signIn()
          return resolve(null)
        } else {
          return resolve(user.session_state)
        }
      })
      .catch(err => {
        console.log(err)
        return reject(err)
      })
  })
}
auth.getSessionState = getSessionState

// Get the access token of the logged in user
function getAcessToken() {
  let self = this
  return new Promise((resolve, reject) => {
    auth
      .getUser()
      .then(user => {
        if (user === null) {
          self.signIn()
          return resolve(null)
        } else {
          return resolve(user.access_token)
        }
      })
      .catch(err => {
        console.log(err)
        return reject(err)
      })
  })
}
auth.getAcessToken = getAcessToken

// Takes the scopes of the logged in user
function getScopes() {
  let self = this
  return new Promise((resolve, reject) => {
    auth
      .getUser()
      .then(user => {
        if (user === null) {
          self.signIn()
          return resolve(null)
        } else {
          return resolve(user.scopes)
        }
      })
      .catch(err => {
        console.log(err)
        return reject(err)
      })
  })
}
auth.getScopes = getScopes

// Get the user roles logged in
function getRole() {
  let self = this
  return new Promise((resolve, reject) => {
    auth
      .getUser()
      .then(user => {
        if (user === null) {
          self.signIn()
          return resolve(null)
        } else {
          return resolve(user.profile.role)
        }
      })
      .catch(err => {
        console.log(err)
        return reject(err)
      })
  })
}
auth.getRole = getRole

export default auth
